import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSortComponent } from "./med-icon-sort.component";

@NgModule({
  declarations: [
    MedIconSortComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSortComponent,
  ],
})
export class MedIconSortModule { }
